// App.vueでEventListenerに登録する処理

import { useRouter } from 'vue-router';
import { useSettings } from '@/config/settings';
import { useCurrentUser } from '@/models/global/currentUser';
import { useLocalStorage } from '@/hooks/utils/useLocalStorage';

export const useSessionCheck = () => {
  const router = useRouter();
  const { settings } = useSettings();
  const { currentUser } = useCurrentUser();
  const { getLocalStorage } = useLocalStorage();

  const clientId = settings.amplify.userPoolWebClientId;

  //別タブのログアウトを検知して現在のタブをサインインページへ飛ばす
  const logoutHandler = (event: StorageEvent) => {
    const target = `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`;

    if (event.key === target && event.newValue === null) {
      router.push('/auth/sign_in');
      return;
    }

    if (event.key === target && event.newValue !== null) {
      window.location.href = '/dashboard';
      return;
    }
  };

  // ブラウザは一定時間操作がないとSLEEPしてJSが無効になる
  // その間はlogoutHandlerが無効化されるため復帰時に認証情報の突合をする
  const visibilityChangeHandler = () => {
    if (document.visibilityState !== 'visible') return;

    const beforeSessionCognitoId = currentUser.value.cognitoId;
    const currentSessionCognitoId = getLocalStorage(
      'App:CurrentUser:CognitoId'
    );

    // ログアウト済み
    if (!currentSessionCognitoId) {
      router.push('/auth/sign_in');
      return;
    }

    // 別のユーザーにログイン中
    if (beforeSessionCognitoId !== currentSessionCognitoId) {
      // 認証情報(app_names)を再取得するためにフルリロード
      window.location.href = router.currentRoute.value.fullPath;
    }
  };

  return { logoutHandler, visibilityChangeHandler };
};
